/***
*
*   SEARCH
*   Search input field
*
*   PROPS
*   throttle: throttle the callback execution in ms
*   callback: function executed on change and submit
*
**********/

import React, { useState, useEffect } from 'react';
import ClassNames from 'classnames';
import Style from './chatInput.module.scss';
import InputStyle from '../form/input/input.module.scss';

export function ChatInput(props){

  const [value, setValue] = useState(props.value || '');
  const [typing, setTyping] = useState(false);
  const [isMultiline, setIsMultiline] = useState(false); // New state to track multi-line mode
  const css = ClassNames([ Style.search, props.className ]);

  useEffect(() => {

    // throttle typing
    if (props.throttle && !typing){
      const onKeyPress = (e) => {
        console.log('ChatInput: value', value);
        if (e.key === 'Enter' && e.shiftKey) {
          e.preventDefault(); // Prevent form submission on Shift+Enter
          setIsMultiline(true); // Enable multi-line mode
        } else {
          setTyping(true);
          setTimeout(() => { setTyping(false) }, props.throttle);
        }
      }

      window.addEventListener('keydown', onKeyPress);
      return () => window.removeEventListener('keydown', onKeyPress);
      
    }
  }, [props.throttle, typing, value]);

  useEffect(() => {

    // callback when typing throttle done
    if (props.throttle && !typing)
      props.callback(value);

  }, [props, typing, value]);

  useEffect(() => {
    if (isMultiline) {
      const textarea = document.querySelector('textarea');
      if (textarea) {
        textarea.focus();
        textarea.setSelectionRange(value.length, value.length); // Move cursor to the end
      }
    }
  }, [isMultiline, value.length]);

  return (
    <form className={ css } onSubmit={ e => e.preventDefault() }>
      {isMultiline ? (
        <textarea
          className={ InputStyle.textbox }
          placeholder={ props.placeholder || '' }
          value={ value }
          onChange={ e => {
            setValue(e.target.value);
          }}
          onKeyDown={ e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              if (!isMultiline) {
                e.preventDefault();
                props.callback(value);
                setValue('');
              }
            }
          }}
          onPaste={ e => {
            const pastedText = e.clipboardData.getData('Text');
            if (pastedText.includes('\n')) {
              setIsMultiline(true); // Enable multi-line mode if pasted text has multiple lines
            }
          }}
        />
      ) : (
        <input
          type='text'
          className={ InputStyle.textbox }
          placeholder={ props.placeholder || '' }
          value={ value }
          onChange={ e => {
            setValue(e.target.value);
          }}
          onKeyDown={ e => {
            if (e.key === 'Enter' && e.shiftKey) {
              e.preventDefault(); // Prevent form submission on Shift+Enter
              setIsMultiline(true); // Enable multi-line mode
            }
          }}
          onPaste={ e => {
            const pastedText = e.clipboardData.getData('Text');
            if (pastedText.includes('\n')) {
              setIsMultiline(true); // Enable multi-line mode if pasted text has multiple lines
            }
          }}
          onInput={ e => {
            const input = e.target;
            if (input.scrollWidth > input.clientWidth) {
              setIsMultiline(true); // Enable multi-line mode if text exceeds the width
            }
          }}
        />
      )}
      <input
        type='submit'
        value=''
        className={ Style.btn }
        onClick={ e => {
          e.preventDefault();
          props.callback(value);
          setValue('');
          setIsMultiline(false); // Exit multi-line mode on submit
        }}
      />
    </form>
  );
}
